module.exports = __webpack_public_path__ + "static/media/trumpetWrong.1614f1df.png";